import React from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import Component from '../components/phone.step.jsx'
import actions from '../actions/phone'
import {push} from 'react-router-redux'

class Container extends React.Component {

  save = () => {
    this.props.save()
      .then(success => {
        if (success) this.props.requestNextStep()
      })
  }

  render() {
    return <Component {...this.props} save={this.save}/>
  }

  static propTypes = {
    requestNextStep: PropTypes.func.isRequired,
    save: PropTypes.func.isRequired,
  }
}

const mapStateToProps = state => {
  const data = state.ui.depositV2.phone
  return {
    countryCode: data.get('countryCode'),
    number: data.get('number'),
    code: data.get('code'),
    open: data.get('open'),
    isSending: data.get('isSending'),
    isSaving: data.get('isSaving'),
    sendError: data.get('sendError'),
    saveError: data.get('saveError'),
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setCountryCode: number => dispatch(actions.setCountryCode(number)),
    setNumber: number => dispatch(actions.setNumber(number)),
    setCode: code => dispatch(actions.setCode(code)),
    sendCode: () => dispatch(actions.sendCode()),
    setOpenDialog: show => dispatch(actions.setOpenDialog(show)),
    save: () => dispatch(actions.save()),
    updateUrl: () => dispatch(push({search: '?s=telefono'})),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Container)



// WEBPACK FOOTER //
// ./src/sections/depositV2/containers/phone.js